// Operator admin schema for the per-caregiver pay-rate override
// (POST /admin/caregivers/:id/pay-rate-override). Sets or clears the custom
// hourly PAY rate for one (caregiver, role); null clears it (falls back to the
// rate-card default). "Effective now" — no effective date; the per-shift
// payRateAtBooking snapshot makes it prospective. See docs/design/11.
import { z } from 'zod';
const ReasonSchema = z
    .string()
    .min(10, 'Reason must be at least 10 characters — document why')
    .max(500);
export const AdminPayRateOverrideRequestSchema = z.object({
    /** The caregiver role to override, by code (e.g. 'PSW', 'RN'). Must be a role
     *  the caregiver actually holds. */
    roleCode: z.string().min(1),
    /** New override in dollars/hour, or null to clear (use the card default).
     *  Floor of 1 cent — NOT just `.positive()`: the service rounds to 2 decimals,
     *  so a sub-cent value like 0.001 would pass `.positive()` yet round to $0.00
     *  and silently store a zero pay rate (defeating the guard). `.min(0.01)`
     *  rejects anything that would round below one cent. (No `multipleOf(0.01)` —
     *  it false-rejects valid rates due to JS float representation.) */
    payRateOverride: z.number().min(0.01).max(10_000).nullable(),
    reason: ReasonSchema,
    /** Sanity-band gate (server-enforced): a rate outside ±50% of the role's
     *  standard rate-card pay is soft-blocked with `409 needs_confirmation` until
     *  the operator re-submits with this true. A rate that is absurd (below 20% or
     *  above 5× standard) is hard-blocked regardless. Clearing the override (null)
     *  is never gated. */
    confirmedOutOfBand: z.boolean().optional().default(false),
});
export const AdminPayRateOverrideResponseSchema = z.object({
    caregiverId: z.string().uuid(),
    roleCode: z.string(),
    payRateOverride: z.number().nullable(),
});
//# sourceMappingURL=pay-rate-override-admin.schema.js.map